import { boolean, nullable, number, object, string } from "superstruct";

export const ProgramAccountCurrentTierSchema = nullable(
    object({
        id: number(),
        title: string(),
        image: nullable(string()),
        pointsMultiplier: nullable(number()),
        achievedAt: nullable(string()),
    })
);

export const ProgramAccountSchema = object({
    isRewardProgramAvailableForCustomer: boolean(),
    marketing: nullable(
        object({
            acceptEmail: boolean(),
            acceptSms: boolean(),
        })
    ),
    points: nullable(
        object({
            balance: number(),
            expiresAt: nullable(string()),
        })
    ),
    tier: nullable(
        object({
            currentTier: ProgramAccountCurrentTierSchema,
            isAllowedToEarnTier: boolean(),
        })
    ),
    referral: nullable(
        object({
            referralLink: nullable(string()),
            isReferralProgramAvailableForCustomer: boolean(),
        })
    ),
});
